import React, { Component } from 'react';
import { Button, Grid, Paper } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import i18n from '../../i18n';

import SimpleDialogFragment from './SimpleDialogFragment';
import '../../assets/stylesheets/Setting.css';

class GenericDeleteModal extends Component {
  handleConfirm = () => {
    const { onDelete, selectedId } = this.props;
    onDelete(selectedId);
  };

  render() {
    const {
      showModal,
      onClose,
      selectedId,
      confirmMessage,
      noSelectionTitle
    } = this.props;

    return (
      <Modal open={showModal} onClose={onClose}>
        <Paper className="deleteModal">
          {selectedId === 0 ? (
            <SimpleDialogFragment
              title={noSelectionTitle}
              buttonLabel={i18n.t('close')}
              onClick={onClose}
            />
          ) : (
            <Grid container>
              <Grid item xs={12}>
                <span>
                  <h3>{confirmMessage}</h3>
                </span>
                <br />
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={this.handleConfirm}
                  className="ssenseButton ssensePrimary"
                >
                  {i18n.t('confirm')}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={onClose}
                  className="ssenseButton ssenseDefault"
                >
                  {i18n.t('cancel')}
                </Button>
              </Grid>
            </Grid>
          )}
        </Paper>
      </Modal>
    );
  }
}

GenericDeleteModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  confirmMessage: PropTypes.string.isRequired,
  noSelectionTitle: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default GenericDeleteModal;
